import { GlIcon, GlIntersperse, GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { s__ } from '~/locale';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import WorkItemTypeIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/work_item_type_icon.vue?vue3';
import workItemTypesConfigurationQuery from '~/work_items/graphql/work_item_types_configuration.query.graphql';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
export default {
    name: 'WorkItemTypeToken',
    components: {
        BaseToken,
        GlIcon,
        GlIntersperse,
        GlFilteredSearchSuggestion,
        WorkItemTypeIcon
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true,
            validator: (config)=>config.fullPath || config.initialWorkItemTypes
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            searchTerm: '',
            workItemTypes: this.config.initialWorkItemTypes || []
        };
    },
    apollo: {
        workItemTypes: {
            query: workItemTypesConfigurationQuery,
            variables () {
                return {
                    fullPath: this.config.fullPath
                };
            },
            update (data) {
                return data?.namespace?.workItemTypes?.nodes || [];
            },
            skip () {
                return !this.config.fullPath;
            },
            error (error) {
                createAlert({
                    message: s__('WorkItem|Something went wrong when fetching work item types. Please try again')
                });
                Sentry.captureException(error);
            }
        }
    },
    computed: {
        filteredWorkItemTypes () {
            const filterName = this.config.isFilterableBoardView ? 'isFilterableBoardView' : 'isFilterableListView';
            return this.workItemTypes.filter((type)=>type[filterName]).filter((type)=>type.name.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()) || this.getTypeValue(type) === this.searchTerm);
        }
    },
    methods: {
        fetchSuggestions (searchTerm) {
            this.searchTerm = searchTerm;
        },
        getActiveType (types, data) {
            return types.find((type)=>this.getTypeValue(type) === data);
        },
        getTypeValue (type) {
            return String(getIdFromGraphQLId(type.id));
        }
    }
};
